import React from 'react';

import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.25),
    padding: theme.spacing(2.25, 2.5),
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    background: 'linear-gradient(130deg, #005f9f 0%, #0d88c9 52%, #31b8e8 100%)',
    boxShadow: '0 18px 34px rgba(16, 73, 105, 0.14)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  heading: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  iconWrap: {
    width: 44,
    height: 44,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.16)',
    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  },
  name: {
    marginBottom: theme.spacing(0.4),
    fontSize: 22,
    fontWeight: 700,
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  description: {
    fontSize: 14,
    lineHeight: 1.7,
    color: 'rgba(255,255,255,0.8)',
  },
  badge: {
    display: 'inline-flex',
    padding: theme.spacing(0.7, 1.3),
    borderRadius: theme.borderRadiusBoxes?.borderRadius || 4,
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.3,
    color: '#fff',
    backgroundColor: 'rgba(255,255,255,0.14)',
    border: '1px solid rgba(255,255,255,0.14)',
  },
  body: {
    display: 'grid',
    gap: theme.spacing(1.5),
  },
}));

function Section({ id, name, description, icon: Icon, badge, enabled, children }) {
  const classes = useStyles();

  if (!enabled) {
    return <></>;
  }

  return (
    <Box id={`help-section-${id}`} className={classes.section}>
      <Box className={classes.header}>
        <Box className={classes.heading}>
          {Icon && (
            <Box className={classes.iconWrap}>
              <Icon />
            </Box>
          )}
          <Box>
            <Box className={classes.name}>{name}</Box>
            {description && <Box className={classes.description}>{description}</Box>}
          </Box>
        </Box>

      </Box>

      <Box className={classes.body}>{children}</Box>
    </Box>
  );
}

export default Section;
